import { DataTable } from '@/components/table/datatable';
import { ColumnDef } from '@tanstack/react-table';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { AppDispatch } from '@/root/store';
import { useLocation, useParams } from 'react-router-dom';
import { GetCommittees, GetPermits } from '@/services/events';

interface Committee {
  id: number;
  filename: string;
  type_label: string;
  filesize: 0;
}

export function OrgEventPermit() {
  const [page, setPage] = useState(1);

  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const { slug } = useParams();

  const { event, permits, paginator, errors } = useSelector(
    (state: any) => state.event
  );

  const queryParams = new URLSearchParams(location.search);
  const searchQuery: string = queryParams.get('search') ?? '';

  useEffect(() => {
    dispatch(GetPermits(slug, searchQuery, page));
  }, [searchQuery, page]);

  const columns: ColumnDef<Committee>[] = [
    {
      header: 'Dokumen',
      cell: ({ row }) => {
        const name = row.original.filename;
        const size = row.original.filesize;
        return (
          <div>
            <p>{name}</p>
            <span className='text-gray-500'>{size/1000}KB</span>
            <div></div>
          </div>
        );
      },
    },
    {
      header: 'Jenis',
      accessorKey: 'type_label',
    },
  ];

  return (
    <>
      <DataTable
        name='Daftar izin acara'
        noun={'izin acara'}
        columns={columns}
        data={permits}
        total={paginator.to}
        currentTotal={paginator.total}
        currentPage={paginator.current_page}
        pages={paginator.last_page}
        onPageRequest={(nextPage) => setPage(nextPage)}
      />
    </>
  );
}
